import React from "react";
import { Box, CircularProgress } from "@mui/material"

export const SearchBackDrop = (props:any) =>{

  return (<Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff8b",
      zIndex: (theme) => theme.zIndex.drawer + 1,
    }}
  >
    <CircularProgress color="inherit" />
    {props.message ? props.message : "검색중..."}
    
  </Box>)  
  
    
  
    // return authCodeList.find((authCode:any)=> authCode.code === role).code_nm.toString()
  }
